import React from 'react'

import { Body3, Heading4, Join, Space, Strong } from '@gousto-internal/citrus-react'
import Immutable from 'immutable'
import { useSelector } from 'react-redux'

import { getNumPortions } from 'selectors/basket'

import { Ingredient } from './Ingredient'

import css from './Ingredients.css'

type IngredientsProps = {
  ingredients: Immutable.List<Immutable.Map<string, any>>
  loading: boolean
}
const Ingredients = ({ ingredients, loading }: IngredientsProps) => {
  const numPortion = useSelector(getNumPortions)
  const people = numPortion > 1 ? 'people' : 'person'

  return (
    <div>
      <div>
        <Join with={<Space size={4} />}>
          <Heading4>Ingredients</Heading4>
          <Body3>For allergens see the &apos;Ingredients contain&apos; section</Body3>
          <Body3>
            Ingredients shown are for{' '}
            <Strong>
              {numPortion} {people}
            </Strong>
            .
          </Body3>
        </Join>
      </div>
      <div className={css.ingredientsContainer}>
        {ingredients
          .filter((ingredient) => {
            if (loading) return true

            const quantity = ingredient?.getIn(['quantities', `for${numPortion}`, 'in_meal'])

            return quantity > 0
          })
          .map((ingredient) => (
            <div className={css.ingredient} key={ingredient && ingredient.get('id')}>
              {ingredient && <Ingredient ingredient={ingredient} loading={loading} />}
            </div>
          ))}
      </div>
    </div>
  )
}

export { Ingredients }
